import React from "react";
import styled from "styled-components";

export default function StatsSection() {
  return (
    <StyledStatsSection>
      <div className="container">
        <ul className="stats-sect__list">
          <li className="stats-sect__item">
            <h1><span>20+</span> год</h1>
            <p>опыт клиники</p>
          </li>
          <li className="stats-sect__item">
            <h1><span>25+</span></h1>
            <p>виды хирургических операций</p>
          </li>
          <li className="stats-sect__item">
            <h1><span>60 000+</span></h1>
            <p>успешные операции</p>
          </li>
        </ul>
      </div>
    </StyledStatsSection>
  );
}

const StyledStatsSection = styled.section`
  background-color: var(--dark-blue);
  padding: 80px 0;

  .stats-sect {
    &__list {
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 32px;
    }

    &__item {
      h1 {
        color: var(--white);
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 40px; /* 125% */
        text-align: center;
        margin-bottom: 6px;

        span {
            font-size: 42px;
        }
      }

      p {
        color: var(--white);
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 125% */
        text-align: center;
      }
    }
  }
`;
